import { UseGqlMutationCallbacks, useMutationOptionsWithInvalidation } from '@alice-financial/api'
import { useMutation } from '@tanstack/react-query'
import { useIntl } from 'react-intl'
import { useMutationNotifier } from '../../../../notifications/useMutationNotifier'
import {
  DeleteWorkLocationAssignmentMutation,
  DeleteWorkLocationAssignmentMutationVariables,
  useDeleteWorkLocationAssignmentMutation,
} from './deleteWorkLocationAssignment_gen'

type UseDeleteWorkLocationAssignmentOptions = UseGqlMutationCallbacks<
  DeleteWorkLocationAssignmentMutation,
  Pick<DeleteWorkLocationAssignmentMutationVariables, 'input'>
>

export const useDeleteWorkLocationAssignment = (
  orgId: number,
  mutationOptions?: UseDeleteWorkLocationAssignmentOptions
) => {
  const intl = useIntl()

  const _mutationOptions = useMutationNotifier(
    {
      onMutate: intl.formatMessage({ id: 'organization.work_locations.deleting_assignment' }),
      onSuccess: intl.formatMessage({ id: 'organization.work_locations.assignment_deleted' }),
    },
    mutationOptions
  )

  // Import the organization query hook dynamically to avoid circular dependencies
  const invalidationKeys = [['OrgDashboard', { orgId }]]

  const mutationOptionsWithInvalidation = useMutationOptionsWithInvalidation(
    _mutationOptions,
    invalidationKeys
  )

  const { mutateAsync: deleteWorkLocationAssignment } = useDeleteWorkLocationAssignmentMutation()

  return useMutation(
    ['deleteWorkLocationAssignment'],
    ({ input }) => deleteWorkLocationAssignment({ input }),
    mutationOptionsWithInvalidation
  )
}
